module.exports = __webpack_public_path__ + "static/media/bg.7368c92b.png";